const getApiUrl = (): string => {
  if (process.env.REACT_APP_API_URL === undefined) {
    throw new Error("No API URL defined.");
  }
  return process.env.REACT_APP_API_URL;
};

export default getApiUrl;
